module.exports = __webpack_public_path__ + "static/media/pk_wh_led.efaa059b.jpg";